import { Component, EventEmitter, Input, Output, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalJobordersService } from 'src/app/_services/global-joborders.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorUtil } from 'src/app/_utilities/error';
import * as _ from "lodash";
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';

@Component({
    selector: 'app-update-location',
    templateUrl: './update-location.component.html',
    styleUrls: ['./update-location.component.scss'],
    standalone: false
})
export class UpdateLocationComponent implements OnInit {
  title = 'Select Location';
  selectedId: string | null = null;
  locationMode: any;
  data: any;
  locationData: any[] = [];

  @ViewChild("addressSearch")
  public addressSearch!: ElementRef;

  
  autocomplete: any;
  autocompleteLsr: any;
  flag: boolean = true;
  homePlaceChanged: boolean = false;
  countries: any[] = [];
  translate: any;
  searchInstallation: string = '';
  public activeState: boolean = false;

  // ── Replaced: gMapsOptions: any ─────────────────────────────────────────────
  mapOptions: google.maps.MapOptions = { scrollwheel: true };
  mapCenter: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  mapZoom: number = 18;

  // ── Replaced: overlays: any (native google.maps.Marker array) ───────────────
  mapMarkers: { position: google.maps.LatLngLiteral; options: google.maps.MarkerOptions }[] = [];


  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public modalRef: BsModalRef,
    private globalJOServc: GlobalJobordersService,
    private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
    private ngZone: NgZone,
    private util: UtilServiceService,
  ) {
    // ── Removed: this.gMapsOptions = { center, zoom, scrollwheel }
    //    Now set as mapCenter / mapZoom / mapOptions properties above
  }

  ngOnInit() {
    this.form = this.fb.group({
      title: [''],
      street: [''],
      city: [''],
      state: [''],
      postcode: ['', Validators.required],
      country: ['', Validators.required]
    });

    console.log("data in update location modal", this.data);
    this.translate = this.data.translate;
    this.countries = this.util.getCountryList();
    this.getLocation();
  }

  /******************** Go to create location mode *****************/
  goCreate() {
    this.title = this.translate?.general.buttons.add.singular +' '+ this.translate?.general.locationDetails.fields.location.singular;
    this.locationMode = 'createWithSearch';
    this.data.installationStreet = '';
    this.data.installationCity = '';
    this.data.installationState = '';
    this.data.installationPostalCode = '';
    this.data.installationCountry = '';
    this.data.installationLatitude = '';
    this.data.installationLongitude = '';
    this.data.placeId = '';
  }

  /******************** Go back to select location mode *****************/
  goBack() {
    this.title = this.translate?.general.buttons.select2.singular +' '+ this.translate?.general.locationDetails.fields.location.singular;
    this.locationMode = 'select';
  }

  /******************** Fetch location based on customer/site/asset/project *****************/
  getLocation() {
    if (this.data.customer.id || this.data.site.id || this.data.assets.id || this.data.project.id) {
      this.locationMode = 'select';
      this.globalJOServc.getJobOrderLocationBaseOnCustomerSiteAssetProject(
        this.data.customer.id ? this.data.customer.id : 0,
        this.data.site.id ? this.data.site.id : 0,
        this.data.assets.id ? this.data.assets.id : 0,
        this.data.project.id ? this.data.project.id : 0,
      ).subscribe((res: any) => {
        if (res && res.body) {
          res.body.forEach((loc: any) => {
            loc.title = 'N/A';
            console.log(this.data.site,"location data before title", loc.siteId);
             console.log(this.data,"location data before title", loc.projectId);
            
             if(this.data.customer && this.data.customer.id === loc.customerId){
              loc.title =this.data.customer?.name ? this.data.customer.name : 'N/A';
              loc.icon = 'assets/svg/leftMenu/customers_r.svg';
             }
            if (this.data.site.id === loc.siteId) {
              loc.title = this.data.site.siteName ? this.data.site.siteName : this.data.site.name;
              loc.icon = 'assets/svg/leftMenu/sites_r.svg';
            }
            if (this.data.assets.id === loc.assetId) {
              loc.title = this.data.assets.name
              loc.icon = 'assets/svg/leftMenu/assets_r.svg';
            }
             if(this.data.project.id === loc.projectId){
              loc.title = this.data.project.name
              loc.icon = 'assets/svg/leftMenu/projects_r.svg';
            }

            if (loc.installationLatitude && loc.installationLongitude) {
              this.locationData.push(loc);
            }
          });

          if (this.locationData.length == 0) {
            this.title = this.translate?.general.buttons.add.singular +' '+ this.translate?.general.locationDetails.fields.location.singular;
            this.locationMode = 'create';
          }
          console.log("location data after title", this.locationData);
        }
      },
      (err: any) => {
        console.log(err, 'error in GET location api');
        this.errorUtil.setErrorMessage(err.status, err.error ? err.error.title : null, err.error ? err.error.title : null, "error", 3000);
      });
    } else {
      this.title = this.translate?.general.buttons.add.singular +' '+ this.translate?.general.locationDetails.fields.location.singular;
      this.locationMode = 'create';
    }
  }

  /******************** Initialize Google Autocomplete Listener *****************/
  initLisner() {
    if (this.autocompleteLsr) {
      google.maps.event.removeListener(this.autocompleteLsr);
    }

    var addressFormatForm: { [key: string]: string } = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      sublocality_level_1: "long_name",
      administrative_area_level_1: "short_name",
      country: "long_name",
      postal_code: "short_name",
    };

    this.autocompleteLsr = this.autocomplete.addListener("place_changed", () => {
      this.homePlaceChanged = true;
      this.data.installationStreet = "";
      this.data.installationCity = "";
      this.data.installationState = "";
      this.data.installationPostalCode = "";
      this.data.installationCountry = "";
      this.data.installationLatitude = "";
      this.data.installationLongitude = "";

      this.ngZone.run(() => {
        let place = this.autocomplete.getPlace();
        if (place.geometry === undefined || place.geometry === null) return;

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        // ── Replaced: new google.maps.Marker + (this.gmap as any).map.panTo + setZoom ──
        this.mapMarkers = [{ position: { lat, lng }, options: { title: "Konyaalti", draggable: true } }];
        this.mapCenter = { lat, lng };
        this.mapZoom = 16;

        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];
          if (addressFormatForm[addressType]) {
            var checkAddress = _.includes(place.address_components[i].types, addressType);
            if (checkAddress) {
              if (["route", "sublocality_level_1", "sublocality", "street_number"].includes(addressType)) {
                if (this.data.installationStreet === "") {
                  this.data.installationStreet += place.address_components[i][addressFormatForm[addressType]];
                } else {
                  this.data.installationStreet += ", " + place.address_components[i][addressFormatForm[addressType]];
                }
              } else if (["locality", "political"].includes(addressType)) {
                this.data.installationCity = place.address_components[i][addressFormatForm[addressType]];
              } else if (addressType === "administrative_area_level_1") {
                this.data.installationState = place.address_components[i][addressFormatForm[addressType]];
              } else if (addressType === "postal_code") {
                this.data.installationPostalCode = place.address_components[i][addressFormatForm[addressType]];
              } else if (addressType === "country") {
                this.data.installationCountry = place.address_components[i][addressFormatForm[addressType]];
              }

              if (place.geometry.location) {
                this.data.installationLatitude = lat;
                this.data.installationLongitude = lng;
              }
            }
          }
        }

        if (place.types.includes("establishment")) {
          this.data.installationStreet = place.name + ", " + this.data.installationStreet;
        }
        this.data.placeId = place.place_id;
      });

      setTimeout(() => { this.homePlaceChanged = false; }, 2000);
    });
  }

  callGoogleAutocomplete() {
    if (this.autocomplete)
      google.maps.event.clearInstanceListeners(this.autocomplete);
    this.autocomplete = new google.maps.places.Autocomplete(
      this.addressSearch.nativeElement,
      { fields: ['place_id', 'geometry', 'name', 'address_components', 'types'] }
    );
    this.initLisner();
  }

  public getPlaceApiCall(event: any) {
    let field = document.getElementById("input_JobOrdersAddressField") as HTMLInputElement;
    let val = event.target.value;

    if (val.length < 3) {
      google.maps.event.removeListener(this.autocompleteLsr);
      google.maps.event.clearInstanceListeners(field);
      if (this.autocomplete) google.maps.event.clearInstanceListeners(this.autocomplete);
      $(".pac-container").remove();
      this.flag = true;
    } else if (this.flag) {
      this.callGoogleAutocomplete();
      this.flag = false;
    }
  }

  updateLocation() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    console.log(this.addressSearch, "updated location data", this.data);
    this.globalJOServc.setJOData(this.data);
    this.modalRef.hide();
  }

  selectLocation(location: any) {
    console.log("selected location", location);
    this.globalJOServc.setJOData(location);
    this.modalRef.hide();
  }

  /******************************************** Toggle Show Map UI ******************************************/
  public toggle(index: number) {
    this.activeState = !this.activeState;
  }

  /******************************************** On Map Clicked ******************************************/
  // ── Replaced: $event.latLng → typed google.maps.MapMouseEvent ───────────────
  public mapClicked(event: google.maps.MapMouseEvent, type: any) {
    if (event.latLng) {
      this.setMapData(event.latLng.lat(), event.latLng.lng(), type);
    }
  }

  /******************************************** On Marker Drag ******************************************/
  // ── Replaced: event.overlay.getPosition() → google.maps.MapMouseEvent ───────
  public markerDragEnd(event: google.maps.MapMouseEvent, addressOf: string) {
    if (event.latLng) {
      this.setMapData(event.latLng.lat(), event.latLng.lng(), addressOf);
    }
  }

  /******************************************** Set Map Marker ******************************************/
  private setMapData(latitude: any, longitude: any, addressOf: string) {
    var addressFormatForm: any = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      sublocality_level_1: "long_name",
      administrative_area_level_1: "short_name",
      country: "long_name",
      postal_code: "short_name",
    };

    var geocoder = new google.maps.Geocoder();
    var latlng = { lat: latitude, lng: longitude };

    if (addressOf === "home") {
      this.homePlaceChanged = true;
      this.data.installationStreet = "";
      this.data.installationCity = "";
      this.data.installationState = "";
      this.data.installationPostalCode = "";
      this.data.installationCountry = "";
      this.data.installationLatitude = "";
      this.data.installationLongitude = "";

      // ── Replaced: new google.maps.Marker + (this.gmap as any).map.panTo + setZoom ──
      this.mapMarkers = [{ position: { lat: latitude, lng: longitude }, options: { draggable: true } }];
      this.mapCenter = { lat: latitude, lng: longitude };
      this.mapZoom = 16;

      geocoder.geocode({ location: latlng }, (results: any, status: any) => {
        if (status == google.maps.GeocoderStatus.OK && results[0]) {
          console.log("results", results);
          this.data.installationLatitude = results[0].geometry.location.lat();
          this.data.installationLongitude = results[0].geometry.location.lng();

          for (var i = 0; i < results[0].address_components.length; i++) {
            var addressType = results[0].address_components[i].types[0];
            if (addressFormatForm[addressType]) {
              var checkAddress = _.includes(results[0].address_components[i].types, addressType);
              if (checkAddress) {
                if (["route", "sublocality_level_1", "sublocality", "street_number"].includes(addressType)) {
                  if (this.data.installationStreet === "") {
                    this.data.installationStreet += results[0].address_components[i][addressFormatForm[addressType]];
                  } else {
                    this.data.installationStreet += ", " + results[0].address_components[i][addressFormatForm[addressType]];
                  }
                } else if (["locality", "political"].includes(addressType)) {
                  this.data.installationCity = results[0].address_components[i][addressFormatForm[addressType]];
                } else if (addressType === "administrative_area_level_1") {
                  this.data.installationState = results[0].address_components[i][addressFormatForm[addressType]];
                } else if (addressType === "postal_code") {
                  this.data.installationPostalCode = results[0].address_components[i][addressFormatForm[addressType]];
                } else if (addressType === "country") {
                  this.data.installationCountry = results[0].address_components[i][addressFormatForm[addressType]];
                }
                this.data.placeId = results[0].place_id;
              }
            }
          }
        }
      });
    }
  }
}